import React from 'react';
import Frame from './Frame';
import Orientations from './Orientations';

const sizes ={
	[Orientations.A4.landscape]: (function() {
		const height = window.innerHeight - (window.innerHeight * 0.1);
		const width = (297 / 210) * height;
		return {width, height};
	}()),
	[Orientations.A4.portrait]: (function() {
		const height = window.innerHeight - (window.innerHeight * 0.1);
		const width = (210 / 297) * height;
		return {width, height};
	}())
};

class Paper extends React.Component {
	render() {
		const { frames, selector, selectedFrame, orientation } = this.props;
		const size = sizes[orientation]
	  	return (
	    	<div id="paper" className="paper" style={size}>
				{frames.map((frame, i) => <Frame key={i} details={frame} isSelected={selectedFrame===frame} onClick={selector(frame)} />)}
	    	</div>
	  	);
	}
}

export default Paper;
